var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-alert',{attrs:{"border":"top","colored-border":"","type":"error","elevation":"2"}},[_vm._v(" Oops, ruta no encontrada, intente volviendo a "),_c('router-link',{attrs:{"to":{ name: 'Home' }}},[_vm._v("Inicio")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }